import { render, staticRenderFns } from "./CreateAccumulateTransaction.vue?vue&type=template&id=62784af4&scoped=true"
import script from "./CreateAccumulateTransaction.vue?vue&type=script&lang=js"
export * from "./CreateAccumulateTransaction.vue?vue&type=script&lang=js"
import style0 from "./CreateAccumulateTransaction.vue?vue&type=style&index=0&id=62784af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62784af4",
  null
  
)

export default component.exports